var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableVideoInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "currentFill"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1993_1286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0289 34.4004C51.4641 34.0808 50.796 34.0896 50.24 34.4226H50.2389L46.0642 36.9272V36.4744C46.0642 34.0275 44.0723 32.0355 41.6253 32.0355H32.51C30.063 32.0355 28.071 34.0275 28.071 36.4744V44.0029C28.071 46.4498 30.063 48.4418 32.51 48.4418H41.6253C44.0723 48.4418 46.0642 46.4498 46.0642 44.0029V43.5501L50.2401 46.0547C50.796 46.3877 51.4641 46.3954 52.029 46.0769C52.5927 45.7573 52.929 45.1791 52.929 44.5322V35.945C52.929 35.298 52.5927 34.72 52.0289 34.4004Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1993_1286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 16.4773,
    fill: "currentColor",
    transform: "translate(28 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableVideoInactive);
export default __webpack_public_path__ + "static/media/DisableVideoInactive.025fbcb738accf7b9df3fa77a8d7fa33.svg";
export { ForwardRef as ReactComponent };